export { default } from "./popup-ad";
